import { render } from "./AccessChecklistStep.vue?vue&type=template&id=6f79ab6a"
import script from "./AccessChecklistStep.vue?vue&type=script&lang=ts"
export * from "./AccessChecklistStep.vue?vue&type=script&lang=ts"
script.render = render

export default script